import { GetConversationsQuery, SendMessageMutation } from '@/modules/common/types';

export type SendMessageConversation = SendMessageMutation['sendMessage']['conversation'];

export type EnhancedConversation = NonNullable<GetConversationsQuery['conversations']>[number] & {
  status: ConversationStatus;
};

export enum ConversationStatus {
  WAITING_FOR_INPUT = 'waitingForInput',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
}
